import Attachments from "./components/Attachments";

export default Attachments;
